import {useNavigate } from "react-router-dom";
import { trainerCourses } from "../components/TrainerCourseData";
// import React, { useState } from 'react';


const TrainerCourseDetail = ({ trainer }) => {
  const navigate = useNavigate();

  // const [isRegisteredUser] = useState(false); // Change to true when logged in


  if (!trainer || !trainer.name) {
    return <p>Trainer data is missing.</p>;
  }


   

  const matchedKey = Object.keys(trainerCourses).find(
    key => key.toLowerCase().trim() === trainer.name.toLowerCase().trim()
  );

  const courses = trainerCourses[matchedKey] || [];
  
  return (
    <div className="trainer-course-container">
      {courses.length === 0 ? (
        <p>No courses assigned to this trainer.</p>
      )
      
      
      : (
        courses.map((course, index) => (

          <div className="course-card-vertical" key={index}>
            <img src={course.image} alt={course.name} className="course-image" />
            <div className="course-text">
              <h3 className="course-name">{course.name}</h3>


              <div className="course-meta">
                <span className="course-duration">{course.duration}</span>
                <span className="course-rating">{course.rating} ⭐</span>
              </div>
              <button
                className="enroll-button"
                onClick={() => navigate(`/courses/${course.id}`)}
              >
                Enroll Now
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
};
export default TrainerCourseDetail;
